import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbdYesNoModal } from '../modal/yes-no.modal.component';

@Injectable()
export class YesNoModalService {
  constructor(private service: NgbModal) { }

  public open(title: string, message: string, settings?: { buttonCallback?: () => void, options?: NgbModalOptions, modalRef?: NgbModalRef }): NgbModalRef {

    if (settings.modalRef) {
      settings.modalRef.close();
    }

    const activeModal: NgbModalRef = settings?.modalRef || this.service.open(NgbdYesNoModal, settings?.options || { centered: true });

    activeModal.componentInstance.title = title;
    activeModal.componentInstance.message = message;
    activeModal.componentInstance.buttonCallback = settings?.buttonCallback;

    return activeModal;
  }
}
